import { Badge } from '@radix-ui/themes';

type BadgeColor = 'blue' | 'amber' | 'gray' | 'purple';

const HIDDEN_ENVS = new Set(['prod', 'production']);

function colorFor(env: string): BadgeColor {
  switch (env.toLowerCase()) {
    case 'dev':
      return 'blue';
    case 'uat':
      return 'amber';
    case 'local':
      return 'gray';
    default:
      return 'purple';
  }
}

/** Environment marker for non-production environments. Renders nothing in production. */
export function EnvBadge({ env }: { env: string | undefined }) {
  if (!env || HIDDEN_ENVS.has(env.toLowerCase())) return null;
  return (
    <Badge color={colorFor(env)} variant="solid" size="1" data-testid="env-badge">
      {env.toUpperCase()}
    </Badge>
  );
}
